import { AfterViewInit, ChangeDetectionStrategy, Component, Injector } from "@angular/core";
import { AgEditorComponent } from "@bfx/ag-grid-angular";
import { LoggerService } from "@bfx/logger";
import { ICellEditorParams } from "ag-grid-community";
import {
  NUMBER_SPINNER_INPUTS,
  NUMBER_SPINNER_VIEW_PROVIDERS,
  ZERO,
} from "shared/base-components/number-spinner.component";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BigNumber } from "shared/cubiq-model-multi-asset";
import { CcyPairPromiseLookupService } from "shared/cubiq-services";
import {
  BfxPriceSpinnerComponent,
  SPINNER_VALUE_ACCESSOR,
} from "../../bfx-interface-controls/bfx-price-spinner.component";
import { BfxFieldNumberDirective } from "../../../shared/base-components/bfx-field-number";
import { BfxInputDirective } from "../../../shared/base-components/bfx-input";

const logger = LoggerService.for(__dirname);

@Component({
  selector: "df-price-spinner",
  templateUrl: "../../../shared/base-components/html/number-spinner.html",
  providers: [SPINNER_VALUE_ACCESSOR],
  viewProviders: NUMBER_SPINNER_VIEW_PROVIDERS,
  inputs: NUMBER_SPINNER_INPUTS,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DfPriceSpinner
  extends BfxPriceSpinnerComponent
  implements AgEditorComponent, AfterViewInit
{
  protected isComponentLeg: boolean;
  protected legEnabled: boolean;
  protected isRowSelected: boolean;

  constructor(
    injector: Injector,
    inputDirective: BfxInputDirective,
    fieldDirective: BfxFieldNumberDirective,
    currencyPairService: CcyPairPromiseLookupService,
  ) {
    super(injector, inputDirective, fieldDirective, currencyPairService);
    this.size = "sm";
  }

  agInit(params: ICellEditorParams): void {
    this.isComponentLeg = params.node.data.isComponentLeg;
    this.legEnabled = params.node.data.legEnabled;
    this.isRowSelected = params.node.isSelected();

    this.isFwd =
      params.node.data.product === CubiqTS.Product.FWD ||
      params.node.data.product === CubiqTS.Product.NDF;
    this.isInverted = params.node.data.invertedOrder;

    if (this.isCancelBeforeStart()) return;

    this.min = this.getMinimum();

    this.updateConfiguration();
    this.updateProductCode(new String(params.node.data.instrument).replace(/\//gi, ""), this.isFwd);
    if (params.value) {
      this.writeValue(new BigNumber(params.value));
    } else {
      this.writeValue(new BigNumber(new BigNumber(0)));
    }
  }

  protected getMinimum(): BigNumber {
    return ZERO;
  }

  getValue(): any {
    if (this.data.textValue) {
      return this.data.value.toFixed(this.config.maxPrecision);
    }
    return new CubiqTS.BigNumber(0).toFixed(this.maxPrecision);
  }

  isCancelBeforeStart?(): boolean {
    return false;
  }

  isCancelAfterEnd?(): boolean {
    return false;
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    setTimeout(() => {
      this.focusInput();
    });
  }
}
